





































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import SignUpForm from '@/components/forms/SignUp.vue';
import { User } from '@/types';

@Component({
  components: { SignUpForm },
})

export default class Home extends Vue {
  @State public user!: User;
}
